exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".threadActivityGraph{height:25px}.threadActivityGraphCanvas{display:block;width:100%;height:100%}.chartViewport.selectedThreadActivityGraphViewport{flex:auto 0 0;border-top:1px solid var(--grey-30)}.selectedThreadActivityGraph{height:30px;-moz-user-focus:ignore}", ""]);

